import { render, staticRenderFns } from "./consent-collection-widget-deploy-step.vue?vue&type=template&id=b2f8288a"
import script from "./consent-collection-widget-deploy-step.vue?vue&type=script&lang=js"
export * from "./consent-collection-widget-deploy-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports